import { Dialog, DialogActions, DialogTitle, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "@common/components/Button";
import {
  EnlargedImageWrapper,
  EnlargedImage,
  TitleText,
  TitleWrapper,
} from "./styled";

interface EnlargeDialogProps {
  title: string;
  imageSrc: string;
  isOpened: boolean;
  onClose: () => void;
}

export const EnlargeDialog = ({
  title,
  imageSrc,
  isOpened,
  onClose,
}: EnlargeDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog maxWidth="sm" fullWidth open={isOpened} onClose={onClose}>
      <DialogTitle>
        <Tooltip title={title} arrow>
          <TitleWrapper>
            <TitleText>{title}</TitleText>
          </TitleWrapper>
        </Tooltip>
      </DialogTitle>

      <EnlargedImageWrapper>
        <EnlargedImage src={imageSrc} alt={t("logo")} />
      </EnlargedImageWrapper>

      <DialogActions sx={(theme) => ({ padding: theme.spacing(2, 3) })}>
        <Button
          color="greyed"
          variant="outlined"
          onClick={onClose}
          data-testid="cancel-button"
        >
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
